import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DialogWithSuccessLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithSuccessLayout';
import Button from '@Components/Button';

import {
  generateJoinString,
  generateFrequencyString,
} from './AlertCreateSuccessDialogUtils';

import './AlertCreateSuccessDialog.custom.scss';

export default function AlertCreateSuccessDialog (props) {
  const {
    query,
    alertName,
    emails,
    frequency,
    dayOfWeek,
    dayOfMonth,
    processOptions,
    databases,

    goToAlerts,
    selfClose,

    className,
    headerClassName,
    headerTitleClassName,
    contentClassName,
    footerClassName,
    headerTitle,
  } = props;

  return (
    <DialogWithSuccessLayout
      {...props}
      className={classnames(className, 'create-alert-success-dialog')}
      character={
        <svg className="create-alert-success-dialog-icon">
          <use xlinkHref="#icon-check" />
        </svg>
      }
      headerClassName={classnames(headerClassName, 'create-alert-success-dialog-header')}
      headerTitleClassName={classnames(headerTitleClassName, 'create-alert-success-dialog-header-title')}
      contentClassName={classnames(contentClassName, 'create-alert-success-dialog-content-wrapper')}
      footerClassName={classnames(footerClassName, 'create-alert-success-dialog-footer')}
      header={headerTitle}
      footer={
        <div className='els-btn-group-right'>
          <Button
            buttonConfig={{
              type: 'tertiary',
              size: 'sm',
              label: 'Open My alerts page',
              e2eName: 'create-alert-success-open-alerts',
            }}
            iconConfig={{ name: 'chevron-right', size: 'sm' }}
            onClick={goToAlerts}
          />
          <Button
            buttonConfig={{
              type: 'primary',
              size: 'sm',
              label: 'Continue using Reaxys',
              e2eName: 'create-alert-success-continue-using',
            }}
            iconConfig={{ name: 'chevron-right', size: 'sm' }}
            onClick={selfClose}
          />
        </div>
      }
    >
      <div className="create-alert-success-dialog-row">
        <div className="create-alert-success-dialog-column-label">Query:</div>
        <div className="create-alert-success-dialog-column-content">{query}</div>
      </div>
      <div className="create-alert-success-dialog-row">
        <div className="create-alert-success-dialog-column-label">Alert name:</div>
        <div className="create-alert-success-dialog-column-content">{alertName}</div>
      </div>
      <div className="create-alert-success-dialog-row">
        <div className="create-alert-success-dialog-column-label">Send alerts to:</div>
        <div className="create-alert-success-dialog-column-content">{generateJoinString(emails)}</div>
      </div>
      <div className="create-alert-success-dialog-row">
        <div className="create-alert-success-dialog-column-label">Frequency:</div>
        <div className="create-alert-success-dialog-column-content">{generateFrequencyString(frequency, dayOfWeek, dayOfMonth)}</div>
      </div>
      <div className="create-alert-success-dialog-row">
        <div className="create-alert-success-dialog-column-label">Include in email:</div>
        <div className="create-alert-success-dialog-column-content">{generateJoinString(processOptions)}</div>
      </div>
      <div className="create-alert-success-dialog-row">
        <div className="create-alert-success-dialog-column-label">From databases:</div>
        <div className="create-alert-success-dialog-column-content">{generateJoinString(databases)}</div>
      </div>
      <div className="create-alert-success-dialog-pre-footer">You can always see, edit and delete the all alerts in the Alerts page.</div>
    </DialogWithSuccessLayout>
  );
}

AlertCreateSuccessDialog.propTypes = {
  query: PropTypes.string.isRequired,
  alertName: PropTypes.string.isRequired,
  emails: PropTypes.array.isRequired,
  frequency: PropTypes.string.isRequired,
  dayOfWeek: PropTypes.string,
  dayOfMonth: PropTypes.string,
  processOptions: PropTypes.array.isRequired,
  databases: PropTypes.array.isRequired,

  goToAlerts: PropTypes.func.isRequired,
  selfClose: PropTypes.func.isRequired,

  className: PropTypes.string,
  headerClassName: PropTypes.string,
  headerTitleClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  footerClassName: PropTypes.string,
};
